var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconAddChildLinks(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "14px",
    viewBox: "0 0 16 14",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Graphics",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Header-child-links",
    transform: "translate(-700.000000, -182.000000)",
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon-add-child-links",
    transform: "translate(700.000000, 182.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1,2.58578644 L4.58578644,2.58578644 C4.85100293,2.58578644 5.10535684,2.4804296 5.29289322,2.29289322 L7.29289322,0.292893219 C7.68341751,-0.0976310729 8.31658249,-0.0976310729 8.70710678,0.292893219 L10.7071068,2.29289322 C10.8946432,2.4804296 11.1489971,2.58578644 11.4142136,2.58578644 L15,2.58578644 C15.5522847,2.58578644 16,3.03350169 16,3.58578644 L16,12.5857864 C16,13.1380712 15.5522847,13.5857864 15,13.5857864 L1,13.5857864 C0.44771525,13.5857864 6.76353751e-17,13.1380712 0,12.5857864 L2.22044605e-16,3.58578644 C3.99672928e-16,3.03350169 0.44771525,2.58578644 1,2.58578644 Z M3.5,5.58578644 C3.22385763,5.58578644 3,5.80964406 3,6.08578644 C3,6.36192881 3.22385763,6.58578644 3.5,6.58578644 L12.5,6.58578644 C12.7761424,6.58578644 13,6.36192881 13,6.08578644 C13,5.80964406 12.7761424,5.58578644 12.5,5.58578644 L3.5,5.58578644 Z M3.5,7.58578644 C3.22385763,7.58578644 3,7.80964406 3,8.08578644 C3,8.36192881 3.22385763,8.58578644 3.5,8.58578644 L12.5,8.58578644 C12.7761424,8.58578644 13,8.36192881 13,8.08578644 C13,7.80964406 12.7761424,7.58578644 12.5,7.58578644 L3.5,7.58578644 Z M3.5,9.58578644 C3.22385763,9.58578644 3,9.80964406 3,10.0857864 C3,10.3619288 3.22385763,10.5857864 3.5,10.5857864 L12.5,10.5857864 C12.7761424,10.5857864 13,10.3619288 13,10.0857864 C13,9.80964406 12.7761424,9.58578644 12.5,9.58578644 L3.5,9.58578644 Z",
    id: "Combined-Shape"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAddChildLinks);
export default __webpack_public_path__ + "static/media/icon-add-child-links.a9a68f43ce9e96bdcf704151c4330469.svg";
export { ForwardRef as ReactComponent };